export class MockBreakpointObserver {
  observe = jasmine.createSpy('observe');
  isMatched = jasmine.createSpy('isMatched');
}
